"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var create_new_model_1 = require("../modules/header-bar/model/create-new.model");
var http_1 = require("@angular/common/http");
var help_item_1 = require("../modules/header-bar/model/help-item");
var shell_header_bar_module_1 = require("../modules/header-bar/shell.header.bar.module");
/**
 * Http implementation to loading header bar items
 */
var HttpHeaderBarService = /** @class */ (function () {
    function HttpHeaderBarService(http) {
        this.http = http;
        this.configsCache = new Map();
    }
    HttpHeaderBarService_1 = HttpHeaderBarService;
    HttpHeaderBarService.prototype.getCreateNewItems = function (configUri) {
        return this.getConfigByUri(configUri)
            .then(function (response) {
            var createNewModel = [];
            for (var _i = 0, _a = response[HttpHeaderBarService_1.CREATE_NEW_ITEMS]; _i < _a.length; _i++) {
                var item = _a[_i];
                createNewModel.push(new create_new_model_1.CreateNewModel(item.id, item.icon, item.titleKey, item.routeLink, item.permissionKey, item.openNewWindow));
            }
            return createNewModel;
        });
    };
    HttpHeaderBarService.prototype.getHelpItems = function (configUri) {
        return this.getConfigByUri(configUri)
            .then(function (response) {
            return response[HttpHeaderBarService_1.HELP_ITEMS].map(function (item) {
                var type = item.type ? item.type : 'link';
                return new help_item_1.HelpItem(item.messageKey, item.url, type, item.subject, item.data);
            });
        });
    };
    HttpHeaderBarService.prototype.showNotificationBell = function (configUri) {
        return this.getConfigByUri(configUri)
            .then(function (response) {
            return Boolean(response[HttpHeaderBarService_1.SHOW_NOTIFICATION_BELL]);
        });
    };
    HttpHeaderBarService.prototype.showUserProfile = function (configUri) {
        return this.getConfigByUri(configUri)
            .then(function (response) {
            return Boolean(response[HttpHeaderBarService_1.SHOW_USER_PROFILE]);
        });
    };
    HttpHeaderBarService.prototype.showAbout = function (configUri) {
        return Promise.resolve(shell_header_bar_module_1.showAboutSection);
    };
    HttpHeaderBarService.prototype.showContact = function (configUri) {
        return Promise.resolve(shell_header_bar_module_1.showContactSection);
    };
    HttpHeaderBarService.prototype.showCalendar = function (configUri) {
        return this.getConfigByUri(configUri)
            .then(function (response) {
            return Boolean(response[HttpHeaderBarService_1.SHOW_CALENDAR]);
        });
    };
    HttpHeaderBarService.prototype.showCalendarText = function (configUri) {
        return this.getConfigByUri(configUri)
            .then(function (response) {
            return Boolean(response[HttpHeaderBarService_1.SHOW_CALENDAR_TEXT]);
        });
    };
    HttpHeaderBarService.prototype.showQRScanner = function (configUri) {
        return this.getConfigByUri(configUri)
            .then(function (response) {
            return Boolean(response[HttpHeaderBarService_1.SHOW_QR_SCANNER]);
        });
    };
    HttpHeaderBarService.prototype.getConfigByUri = function (configUri) {
        if (this.configsCache.has(configUri)) {
            return this.configsCache.get(configUri);
        }
        else {
            var promise = this.http
                .get(configUri)
                .toPromise();
            this.configsCache.set(configUri, promise);
            return promise;
        }
    };
    var HttpHeaderBarService_1;
    HttpHeaderBarService.CREATE_NEW_ITEMS = 'createNewItems';
    HttpHeaderBarService.HELP_ITEMS = 'help';
    HttpHeaderBarService.SHOW_NOTIFICATION_BELL = 'showNotificationBell';
    HttpHeaderBarService.SHOW_USER_PROFILE = 'showUserProfile';
    HttpHeaderBarService.SHOW_CALENDAR = 'showCalendar';
    HttpHeaderBarService.SHOW_CALENDAR_TEXT = 'showCalendarText';
    HttpHeaderBarService.SHOW_QR_SCANNER = 'showQRScanner';
    HttpHeaderBarService = HttpHeaderBarService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], HttpHeaderBarService);
    return HttpHeaderBarService;
}());
exports.HttpHeaderBarService = HttpHeaderBarService;
//# sourceMappingURL=http-header-bar.service.js.map